import React from "react";
import { Check } from "lucide-react";

const PREVIEW_IMG = "/images/spending-plan-running-balance-mobile.png";

/**
 * Product preview — a real mobile screenshot of the Spending Plan's
 * Running Balance (sample data), plus the same four benefits for every persona.
 */
export const ProductPreview = ({ benefits = [] }) => (
  <section className="mt-12" data-testid="result-product-preview">
    <p className="eyebrow text-[#A9712A]">Inside Financial Habits to Succeed</p>
    <h2 className="font-serif text-3xl sm:text-4xl text-[#2C302E] mt-2 leading-tight">
      Your bills, income, and savings — with the balance 90 days ahead.
    </h2>
    <div className="mt-8 grid grid-cols-1 md:grid-cols-[300px_1fr] gap-8 items-start">
      <figure className="mx-auto md:mx-0 w-full max-w-[300px]">
        <div className="rounded-[28px] border-[6px] border-[#2C302E] bg-[#2C302E] shadow-lg overflow-hidden">
          <img
            src={PREVIEW_IMG}
            alt="Mobile view of the Spending Plan Running Balance showing dated bills, a paycheck, savings, and the projected balance after each one, using sample information"
            className="block w-full h-auto"
            loading="lazy"
            data-testid="result-product-preview-image"
          />
        </div>
        <figcaption className="mt-2 text-center text-xs text-[#787671]" data-testid="result-product-preview-caption">
          Example using sample information.
        </figcaption>
      </figure>
      <ul className="space-y-4 md:pt-2" data-testid="result-product-preview-benefits">
        {benefits.map((b) => (
          <li key={b} className="flex items-start gap-3">
            <span className="shrink-0 mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#3E6B37] text-white">
              <Check className="h-3.5 w-3.5" />
            </span>
            <span className="text-[#2C302E] leading-relaxed">{b}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
